// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"de112579","168":"8bcaff0a","461":"21e00885","463":"de112579"}[chunkId] + ".css";
};